import { Node } from 'slate';

const withDisabled = editor => {
	// Returns true if headings are disabled
	editor.isHeadingDisabled = () => {
		return editor.isInHeading()
			? false
			: !editor.isElementActive('paragraph');
	};
		
	// Returns true if marking is disabled
	editor.isMarkDisabled = () => {
		return editor.isInHeading()
			|| editor.isElementActive('image')
			|| editor.isElementActive('video')
			|| editor.isElementActive('audio');
	};

	// Returns true if highlighting is disabled
	editor.isHighlightDisabled = () => {
		return editor.isInHeading()
			|| editor.isElementActive('image')
			|| editor.isElementActive('video')
			|| editor.isElementActive('audio');
	};

	// Returns true if alignments are disabled
	editor.isAlignDisabled = () => {
		return editor.isInHeading()
			|| editor.isInList()
			|| editor.isInQuiz()
			|| editor.isElementActive('blockquote');
	};

	// Returns true if blockquote is disabled
	editor.isBlockquoteDisabled = () => {
		return editor.isElementActive('blockquote')
			? false
			: !editor.isElementActive('paragraph');
	};

	// Returns true if link is disabled
	editor.isLinkDisabled = () => {
		return (editor?.selection && Node.fragment(editor, editor?.selection).length > 1)
			|| editor.isInHeading()
			|| editor.isElementActive('image')
			|| editor.isElementActive('video')
			|| editor.isElementActive('audio');
	};

	// Returns true if media is disabled
	editor.isMediaDisabled = () => {
		return editor.isInHeading()
			|| editor.isInList()
			|| editor.isInQuiz()
			|| editor.isInTable()
			|| editor.isElementActive('blockquote');
	};

	// Returns true if formula is disabled
	editor.isFormulaDisabled = () => {
		return editor.isInHeading()
			|| editor.isElementActive('image')
			|| editor.isElementActive('video')
			|| editor.isElementActive('audio');
	};

	// Returns true if table is disabled
	editor.isTableDisabled = () => {
		return editor.isInHeading()
			|| editor.isInList()
			|| editor.isInQuiz()
			|| editor.isElementActive('image')
			|| editor.isElementActive('video')
			|| editor.isElementActive('audio')
			|| editor.isElementActive('blockquote');
	};

	// Returns true if table is disabled
	editor.isYoutubeDisabled = () => {
		return !editor.isElementActive('paragraph');
	};

	// Returns true if table is disabled
	editor.isDownloadDisabled = () => {
		return editor.isElementActive('download')
			? false
			: !editor.isElementActive('paragraph');
	};

	// Returns true if list is disabled
	editor.isListDisabled = () => {
		return editor.isInHeading()
			|| editor.isInTable()
			|| editor.isInQuiz()
			|| editor.isElementActive('blockquote');
	};

	// Returns true if quiz is disabled
	editor.isQuizDisabled = () => {
		return editor.isInQuiz()
			? false
			: !editor.isElementActive('paragraph');
	};

	return editor;
};

export default withDisabled;